(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-delivery-countdown]');

    const getParts = (date, timezone) => {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(date);

      return Object.fromEntries(parts.map((part) => [part.type, part.value]));
    };

    const localDate = (parts) => new Date(
      `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}+03:00`
    );

    const moveIntoProductForm = (root) => {
      const productInfo = document.querySelector('.pdp__info');
      const cta = productInfo?.querySelector('.pdp__cta-row');
      const oldCargo = productInfo?.querySelector('.pdp__cargo');
      if (!cta) return;
      if (oldCargo) oldCargo.hidden = true;
      const sidebar = document.querySelector('.nn-premium-product .pdp__side');
      if (sidebar) sidebar.append(root);
      else cta.before(root);
    };

    const update = (root) => {
      const timezone = root.dataset.timezone || 'Europe/Istanbul';
      const parts = getParts(new Date(), timezone);
      const now = localDate(parts);
      const cutoffHour = Number(root.dataset.cutoffHour || 15);
      const cutoffMinute = Number(root.dataset.cutoffMinute || 0);
      const target = new Date(now);
      target.setUTCHours(cutoffHour - 3, cutoffMinute, 0, 0);

      const localWeekday = new Date(`${parts.year}-${parts.month}-${parts.day}T12:00:00Z`).getUTCDay();
      let daysToAdd = 0;
      let shipLabel = 'bugün';

      if (localWeekday === 6) {
        daysToAdd = 2;
        shipLabel = 'pazartesi';
      } else if (localWeekday === 0) {
        daysToAdd = 1;
        shipLabel = 'pazartesi';
      } else if (now >= target) {
        daysToAdd = localWeekday === 5 ? 3 : 1;
        shipLabel = localWeekday === 5 ? 'pazartesi' : 'sonraki iş günü';
      }

      target.setUTCDate(target.getUTCDate() + daysToAdd);
      const diff = Math.max(0, target.getTime() - now.getTime());
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const message = root.dataset.beforeTemplate
        .replace('[saat]', `<strong>${hours} saat</strong>`)
        .replace('[dakika]', `<strong>${minutes} dakika</strong>`)
        .replace('[gün]', shipLabel);

      root.querySelector('[data-delivery-message]').innerHTML = message;
    };

    roots.forEach((root) => {
      moveIntoProductForm(root);
      update(root);
      window.setInterval(() => update(root), 30000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.querySelectorAll('[data-slider]').forEach((slider, side) => {
        const slides = Array.from(slider.querySelectorAll('[data-slide]'));
        const track = slider.querySelector('[data-track]');
        const dots = slider.querySelector('[data-dots]');
        const pause = slider.querySelector('[data-pause]');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const delay = Number(root.dataset.delay) + side * 1100;
        let current = 0, timer, touchX, touchY, userPaused = reduced.matches;
        function show(index) {
          if (!slides.length) return;
          current = (index + slides.length) % slides.length;
          track.style.transform = `translateX(-${current * 100}%)`;
          slides.forEach((slide, i) => { slide.inert = i !== current; slide.setAttribute('aria-hidden', i === current ? 'false' : 'true'); });
          Array.from(dots.children).forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
        }
        function stop() { window.clearInterval(timer); }
        function start() { stop(); if (userPaused || reduced.matches || document.hidden || slides.length < 2 || slider.matches(':hover') || slider.contains(document.activeElement)) return; timer = window.setInterval(() => show(current + 1), delay); }
        function updatePause() { pause.setAttribute('aria-pressed', String(userPaused)); pause.setAttribute('aria-label', userPaused ? pause.dataset.playLabel : pause.dataset.pauseLabel); pause.querySelector('[data-pause-icon]').textContent = userPaused ? '▶' : 'Ⅱ'; }
        slides.forEach((slide, i) => {
          const dot = document.createElement('button');
          dot.type = 'button'; dot.setAttribute('aria-label', `${slider.getAttribute('aria-label')} ${i + 1}`);
          dot.addEventListener('click', () => { show(i); start(); }); dots.appendChild(dot);
        });
        slider.querySelector('[data-prev]').addEventListener('click', () => { show(current - 1); start(); });
        slider.querySelector('[data-next]').addEventListener('click', () => { show(current + 1); start(); });
        pause.addEventListener('click', () => { userPaused = !userPaused; updatePause(); start(); });
        slider.addEventListener('mouseenter', stop); slider.addEventListener('mouseleave', start);
        slider.addEventListener('focusin', stop); slider.addEventListener('focusout', () => setTimeout(start, 0));
        slider.addEventListener('keydown', e => { if (e.target !== slider) return; if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); show(current + (e.key === 'ArrowRight' ? 1 : -1)); start(); } });
        slider.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; stop(); }, { passive: true });
        slider.addEventListener('touchend', e => { if (touchX !== undefined && !e.target.closest('.nn-dual-hero__products')) { const dx = e.changedTouches[0].clientX - touchX, dy = e.changedTouches[0].clientY - touchY; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1)); } touchX = undefined; start(); }, { passive: true });
        document.addEventListener('visibilitychange', start);
        reduced.addEventListener('change', () => { userPaused = reduced.matches; updatePause(); start(); });
        document.addEventListener('shopify:block:select', e => { const index = slides.findIndex(slide => slide.contains(e.target) || slide === e.target); if (index !== -1) { userPaused = true; updatePause(); show(index); stop(); } });
        show(0); updatePause(); start();
      });
    }
    document.querySelectorAll('[data-dual-hero]').forEach(init);
    document.addEventListener('shopify:section:load', e => { e.target.querySelectorAll('[data-dual-hero]').forEach(init); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-autocomplete-fix"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-header-search-form]');
    var input = document.querySelector('[data-header-search-input]');
    var results = document.querySelector('[data-header-live-results]');
    if (!form || !input || !results || input.dataset.autocompleteInline === 'true') return;

    input.dataset.autocompleteInline = 'true';
    input.dataset.liveSearchEnhanced = 'true';
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', 'HeaderLiveSearchResults');
    results.id = 'HeaderLiveSearchResults';

    var timer;
    var controller;
    var activeIndex = -1;

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoney(value) {
      var amount = Number(value || 0);
      try {
        return new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: results.dataset.currency || 'TRY'
        }).format(Number.isFinite(amount) ? amount : 0);
      } catch (error) {
        return amount.toFixed(2).replace('.', ',') + ' TL';
      }
    }

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function showState(message) {
      results.innerHTML = '<p class="hdr-live-search__state" role="status">' + escapeHtml(message) + '</p>';
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function render(data, query) {
      var predictive = data && data.resources && data.resources.results;
      var limit = window.matchMedia('(max-width: 749px)').matches ? 4 : 6;
      var products = predictive && predictive.products ? predictive.products.slice(0, limit) : [];
      if (!products.length) {
        showState('Ürün bulunamadı.');
        return;
      }

      var items = products.map(function (product, index) {
        var image = product.featured_image && product.featured_image.url;
        var imageUrl = image ? image + (image.indexOf('?') === -1 ? '?width=116' : '&width=116') : '';
        var price = Number(product.price_min != null ? product.price_min : product.price);
        var compareAt = Number(product.compare_at_price_min || 0);
        var available = product.available === true;
        var imageHtml = imageUrl
          ? '<img class="hdr-live-search__image" src="' + escapeHtml(imageUrl) + '" alt="" width="58" height="58" loading="lazy">'
          : '<span class="hdr-live-search__image--empty" aria-hidden="true"></span>';
        var compareHtml = compareAt > price
          ? '<span class="hdr-live-search__compare">' + formatMoney(compareAt) + '</span>'
          : '';

        return '<li><a class="hdr-live-search__item" role="option" aria-selected="false" data-header-search-option data-option-index="' + index + '" href="' + escapeHtml(product.url) + '">' +
          imageHtml +
          '<span class="hdr-live-search__details"><span class="hdr-live-search__title">' + escapeHtml(product.title) + '</span>' +
          '<span class="hdr-live-search__stock' + (available ? '' : ' is-unavailable') + '">' + (available ? 'Stokta var' : 'Stokta yok') + '</span></span>' +
          '<span class="hdr-live-search__prices">' + compareHtml + '<span class="hdr-live-search__price">' + formatMoney(price) + '</span></span>' +
          '</a></li>';
      }).join('');

      var allUrl = '/search?q=' + encodeURIComponent(query) + '&type=product';
      results.innerHTML = '<ul class="hdr-live-search__list" role="listbox">' + items + '</ul>' +
        '<a class="hdr-live-search__all" href="' + allUrl + '">Tüm sonuçları gör</a>';
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function search(value) {
      var query = String(value || '').trim();
      window.clearTimeout(timer);
      if (query.length < 2) {
        if (controller) controller.abort();
        closeResults();
        return;
      }

      showState('Aranıyor…');
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var endpoint = results.dataset.predictiveUrl || '/search/suggest';
        var url = endpoint.replace(/\.json$/, '').replace(/\/$/, '') + '.json';
        var params = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,vendor'
        });

        fetch(url + '?' + params.toString(), {
          signal: controller.signal,
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search failed');
            return response.json();
          })
          .then(function (data) {
            if (input.value.trim() === query) render(data, query);
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') showState('Arama sonuçları şu anda yüklenemiyor.');
          });
      }, 100);
    }

    input.addEventListener('input', function () { search(input.value); });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) search(input.value);
    });
    input.addEventListener('keydown', function (event) {
      var options = Array.prototype.slice.call(results.querySelectorAll('[data-header-search-option]'));
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        activeIndex = (activeIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach(function (option, index) {
          var active = index === activeIndex;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        options[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && activeIndex >= 0 && options[activeIndex]) {
        event.preventDefault();
        window.location.href = options[activeIndex].href;
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    form.addEventListener('submit', closeResults);
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) closeResults();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHeaderLiveSearch() {
      if (window.NNHeaderLiveSearch && typeof window.NNHeaderLiveSearch.refresh === 'function') {
        window.NNHeaderLiveSearch.refresh();
        return;
      }

      var state = {
        timer: null,
        controller: null,
        activeIndex: -1,
        input: null,
        form: null,
        results: null
      };

      function escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function highlight(value, query) {
        var text = String(value || '');
        var needle = String(query || '').trim();
        if (!needle) return escapeHtml(text);
        var source = text.toLocaleLowerCase('tr-TR');
        var normalizedNeedle = needle.toLocaleLowerCase('tr-TR');
        var output = '';
        var cursor = 0;
        var matchIndex = source.indexOf(normalizedNeedle);

        while (matchIndex !== -1) {
          output += escapeHtml(text.slice(cursor, matchIndex));
          output += '<mark>' + escapeHtml(text.slice(matchIndex, matchIndex + needle.length)) + '</mark>';
          cursor = matchIndex + needle.length;
          matchIndex = source.indexOf(normalizedNeedle, cursor);
        }

        return output + escapeHtml(text.slice(cursor));
      }

      function formatMoney(value, currency) {
        var amount = Number(value || 0);
        if (!Number.isFinite(amount)) amount = 0;
        try {
          return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: currency || 'TRY'
          }).format(amount);
        } catch (error) {
          return amount.toFixed(2).replace('.', ',') + ' TL';
        }
      }

      function findParts(input) {
        var form = input && input.closest('[data-header-search-form]');
        if (!form) return null;

        var results = form.querySelector('[data-header-live-results]');
        if (!results && state.form === form && state.results && document.body.contains(state.results)) {
          results = state.results;
        }
        if (!results) return null;

        document.querySelectorAll('body > [data-header-live-results]').forEach(function (candidate) {
          if (candidate !== results) candidate.remove();
        });

        if (results.parentElement !== document.body) document.body.appendChild(results);

        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-controls', 'HeaderLiveSearchResults');
        results.id = 'HeaderLiveSearchResults';

        state.input = input;
        state.form = form;
        state.results = results;
        return state;
      }

      function positionResults() {
        if (!state.form || !state.results || state.results.hidden || !document.body.contains(state.form)) return;
        var rect = state.form.getBoundingClientRect();
        var viewportPadding = 8;
        var left = Math.max(viewportPadding, Math.min(rect.left, window.innerWidth - viewportPadding));
        var width = Math.min(rect.width, window.innerWidth - left - viewportPadding);
        var top = rect.bottom + 6;
        var availableHeight = Math.max(160, window.innerHeight - top - viewportPadding);

        state.results.style.left = left + 'px';
        state.results.style.top = top + 'px';
        state.results.style.width = width + 'px';
        state.results.style.maxHeight = Math.min(640, availableHeight) + 'px';
      }

      function closeResults() {
        window.clearTimeout(state.timer);
        if (state.controller) state.controller.abort();
        if (state.results) {
          state.results.hidden = true;
          state.results.innerHTML = '';
        }
        if (state.input) state.input.setAttribute('aria-expanded', 'false');
        state.activeIndex = -1;
      }

      function showState(message) {
        if (!state.results || !state.input) return;
        state.results.innerHTML = '<p class="hdr-live-search__state" role="status">' + escapeHtml(message) + '</p>';
        state.results.hidden = false;
        state.input.setAttribute('aria-expanded', 'true');
        positionResults();
      }

      function renderResults(data, query) {
        if (!state.results || !state.input) return;
        var predictive = data && data.resources && data.resources.results;
        var limit = window.innerWidth <= 749 ? 4 : 6;
        var products = predictive && predictive.products ? predictive.products.slice(0, limit) : [];

        if (!products.length) {
          showState('Ürün bulunamadı.');
          return;
        }

        var currency = state.results.dataset.currency || 'TRY';
        var items = products.map(function (product, index) {
          var image = product.featured_image && product.featured_image.url;
          var imageUrl = image ? image + (image.indexOf('?') === -1 ? '?width=160' : '&width=160') : '';
          var price = Number(product.price_min != null ? product.price_min : product.price);
          var compareAt = Number(product.compare_at_price_min || 0);
          var available = product.available === true;
          var imageHtml = imageUrl
            ? '<img class="hdr-live-search__image" src="' + escapeHtml(imageUrl) + '" alt="" width="64" height="64" loading="lazy">'
            : '<span class="hdr-live-search__image--empty" aria-hidden="true"></span>';
          var compareHtml = compareAt > price
            ? '<span class="hdr-live-search__compare">' + formatMoney(compareAt, currency) + '</span>'
            : '';

          return '<li><a class="hdr-live-search__item" role="option" aria-selected="false" data-header-search-option data-option-index="' + index + '" href="' + escapeHtml(product.url) + '">' +
            imageHtml +
            '<span class="hdr-live-search__details"><span class="hdr-live-search__title">' + highlight(product.title, query) + '</span>' +
            '<span class="hdr-live-search__stock' + (available ? '' : ' is-unavailable') + '">' + (available ? 'Stokta var' : 'Stokta yok') + '</span></span>' +
            '<span class="hdr-live-search__prices">' + compareHtml + '<span class="hdr-live-search__price">' + formatMoney(price, currency) + '</span></span>' +
            '</a></li>';
        }).join('');

        var allUrl = '/search?q=' + encodeURIComponent(query) + '&type=product';
        state.results.innerHTML = '<div class="hdr-live-search__head"><span class="hdr-live-search__query">' + escapeHtml(query) + '</span><span class="hdr-live-search__count">' + products.length + '</span><button type="button" class="hdr-live-search__close" data-header-search-close aria-label="Aramayı kapat">×</button></div>' +
          '<ul class="hdr-live-search__list" role="listbox">' + items + '</ul>' +
          '<a class="hdr-live-search__all" href="' + allUrl + '">Tüm sonuçları gör</a>';
        state.results.hidden = false;
        state.input.setAttribute('aria-expanded', 'true');
        state.activeIndex = -1;
        positionResults();
      }

      function search(input) {
        var parts = findParts(input);
        if (!parts) return;
        var query = String(input.value || '').trim();
        window.clearTimeout(state.timer);

        if (query.length < 2) {
          closeResults();
          return;
        }

        showState('Aranıyor…');
        state.timer = window.setTimeout(function () {
          if (state.controller) state.controller.abort();
          state.controller = new AbortController();

          var endpoint = state.results.dataset.predictiveUrl || '/search/suggest';
          var url = endpoint.replace(/\.json$/, '').replace(/\/$/, '') + '.json';
          var params = new URLSearchParams({
            q: query,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,vendor'
          });

          fetch(url + '?' + params.toString(), {
            signal: state.controller.signal,
            headers: { Accept: 'application/json' }
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Predictive search failed');
              return response.json();
            })
            .then(function (data) {
              if (state.input === input && input.value.trim() === query) renderResults(data, query);
            })
            .catch(function (error) {
              if (error.name !== 'AbortError') showState('Arama sonuçları şu anda yüklenemiyor.');
            });
        }, 120);
      }

      function moveSelection(direction) {
        if (!state.results || state.results.hidden) return;
        var options = Array.prototype.slice.call(state.results.querySelectorAll('[data-header-search-option]'));
        if (!options.length) return;

        state.activeIndex = (state.activeIndex + direction + options.length) % options.length;
        options.forEach(function (option, index) {
          var active = index === state.activeIndex;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        options[state.activeIndex].scrollIntoView({ block: 'nearest' });
      }

      function refresh() {
        if (state.input && !document.body.contains(state.input)) closeResults();
        var input = document.querySelector('[data-header-search-input]');
        if (input) {
          input.setAttribute('aria-autocomplete', 'list');
          input.setAttribute('aria-expanded', 'false');
          input.setAttribute('aria-controls', 'HeaderLiveSearchResults');
        }
      }

      document.addEventListener('input', function (event) {
        if (event.target.matches('[data-header-search-input]')) search(event.target);
      });

      document.addEventListener('focusin', function (event) {
        if (event.target.matches('[data-header-search-input]') && event.target.value.trim().length >= 2) {
          search(event.target);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (!event.target.matches('[data-header-search-input]')) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          moveSelection(1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          moveSelection(-1);
        } else if (event.key === 'Enter' && state.activeIndex >= 0 && state.results) {
          var active = state.results.querySelector('[data-option-index="' + state.activeIndex + '"]');
          if (active) {
            event.preventDefault();
            window.location.href = active.href;
          }
        } else if (event.key === 'Escape') {
          closeResults();
        }
      });

      document.addEventListener('submit', function (event) {
        if (event.target.matches('[data-header-search-form]')) closeResults();
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-header-search-close]')) {
          closeResults();
          return;
        }
        if ((state.form && state.form.contains(event.target)) || (state.results && state.results.contains(event.target))) return;
        closeResults();
      });

      window.addEventListener('resize', positionResults);
      window.addEventListener('scroll', positionResults, true);
      document.addEventListener('shopify:section:load', function () {
        closeResults();
        window.setTimeout(refresh, 0);
      });

      window.NNHeaderLiveSearch = {
        close: closeResults,
        refresh: refresh,
        search: search
      };
      refresh();
    }

    initHeaderLiveSearch();

    function initHeader() {
      var header = document.querySelector('[data-header-section]');
      var dialog = document.getElementById('HeaderSearchDialog');
      var headerInput = document.querySelector('[data-header-search-input]');
      var dialogInput = document.querySelector('[data-search-dialog-input]');
      var defaultContent = document.querySelector('[data-search-default]');
      var results = document.querySelector('[data-search-results]');
      var status = document.querySelector('[data-search-status]');
      var closeButton = document.querySelector('[data-search-close]');
      var drawer = document.getElementById('MobileDrawer');
      var burger = document.querySelector('[data-drawer-open]');
      var searchTimer;
      var requestController;
      var typingTimer;
      var suppressHeaderFocus = false;

      if (!header) return;
      if (header.dataset.enhanced === 'true') return;
      header.dataset.enhanced = 'true';

      // Mega panel rayı: hangi L2'nin paneli açık olacağını işaretler.
      // CSS yalnızca `.is-active` sınıfına bakar; sunucu ilk öğeyi aktif
      // gönderdiği için JS çalışmasa da panel dolu görünür.
      function fitMegaPanel(mega) {
        if (!window.matchMedia('(min-width:1024px)').matches || !mega.offsetWidth) return;
        var host = mega.offsetParent;
        if (!host) return;
        var available = host.clientWidth;
        var width = Math.min(available, 1220);
        var trigger = mega.closest('.nav-horizontal__item');
        var origin = trigger ? trigger.getBoundingClientRect().left - host.getBoundingClientRect().left - 18 : 0;
        var left = Math.max(0, Math.min(available - width, origin));
        var top = mega.getBoundingClientRect().top;
        var height = Math.max(260, Math.min(420, window.innerHeight - top - 16));
        if (mega.style.width !== width + 'px') mega.style.width = width + 'px';
        if (mega.style.left !== left + 'px') mega.style.left = left + 'px';
        if (mega.style.getPropertyValue('--mega-h') !== Math.ceil(height) + 'px') {
          mega.style.setProperty('--mega-h', Math.ceil(height) + 'px');
        }
      }
      header.querySelectorAll('[data-mega]').forEach(function (mega) {
        var items = Array.prototype.slice.call(mega.querySelectorAll('[data-mega-item]'));
        if (!items.length) return;

        items.forEach(function (item) {
          var pane = item.querySelector('.mega__pane');
          if (pane) pane.setAttribute('aria-hidden', item.classList.contains('is-active') ? 'false' : 'true');
        });

        function activate(target) {
          items.forEach(function (item) {
            var active = item === target;
            item.classList.toggle('is-active', active);
            var pane = item.querySelector('.mega__pane');
            if (pane) pane.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        }

        items.forEach(function (item) {
          item.addEventListener('mouseenter', function () { activate(item); });
          item.addEventListener('focusin', function () { activate(item); });
        });

        // Menüden çıkınca ilk panele dön, böylece sonraki açılış tutarlı olur.
        var trigger = mega.closest('.nav-horizontal__item');
        if (trigger) {
          trigger.addEventListener('mouseleave', function () { activate(items[0]); });
        }
      });

      function openSearch(value) {
        if (!dialog || !dialogInput) return;
        if (!dialog.open) dialog.showModal();
        dialogInput.value = value || '';
        window.setTimeout(function () {
          dialogInput.focus();
          dialogInput.setSelectionRange(dialogInput.value.length, dialogInput.value.length);
        }, 60);
        if (dialogInput.value.trim().length > 1) runSearch(dialogInput.value);
      }

      function closeSearch() {
        if (dialog && dialog.open) {
          suppressHeaderFocus = true;
          dialog.close();
          window.setTimeout(function () {
            suppressHeaderFocus = false;
          }, 150);
        }
      }

      function setDefaultState() {
        defaultContent.hidden = false;
        results.hidden = true;
        results.innerHTML = '';
        status.textContent = '';
      }

      function escapeHtml(value) {
        var element = document.createElement('div');
        element.textContent = value || '';
        return element.innerHTML;
      }

      function renderResults(data, query) {
        var resourceResults = data && data.resources && data.resources.results;
        var products = resourceResults && resourceResults.products ? resourceResults.products : [];
        var collections = resourceResults && resourceResults.collections ? resourceResults.collections : [];
        var pages = resourceResults && resourceResults.pages ? resourceResults.pages : [];
        var articles = resourceResults && resourceResults.articles ? resourceResults.articles : [];
        var items = [];

        products.forEach(function (product) {
          var image = product.featured_image && (product.featured_image.url || product.featured_image);
          var imageUrl = image ? image + (image.indexOf('?') === -1 ? '?width=180' : '&width=180') : '';
          items.push(
            '<a class="header-search-result" href="' + escapeHtml(product.url) + '">' +
              (imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="" width="68" height="68">' : '<span class="header-search-result__empty"></span>') +
              '<span><strong>' + escapeHtml(product.title) + '</strong><small>' + escapeHtml(product.vendor || results.dataset.labelProduct) + '</small></span>' +
            '</a>'
          );
        });

        collections.concat(pages, articles).forEach(function (resource) {
          items.push(
            '<a class="header-search-result" href="' + escapeHtml(resource.url) + '">' +
              '<span class="header-search-result__empty"></span>' +
              '<span><strong>' + escapeHtml(resource.title) + '</strong><small>' + escapeHtml(results.dataset.labelContent) + '</small></span>' +
            '</a>'
          );
        });

        defaultContent.hidden = true;
        results.hidden = false;
        status.textContent = items.length
          ? query + results.dataset.labelShowing
          : query + results.dataset.labelEmpty;
        results.innerHTML =
          '<div class="header-search-results__heading"><h3>' + escapeHtml(results.dataset.labelResults) + '</h3><a href="/search?q=' + encodeURIComponent(query) + '">' + escapeHtml(results.dataset.labelViewAll) + '</a></div>' +
          '<div class="header-search-results__grid">' + items.join('') + '</div>';
      }

      function runSearch(value) {
        var query = value.trim();
        window.clearTimeout(searchTimer);
        if (query.length < 2) {
          if (requestController) requestController.abort();
          setDefaultState();
          return;
        }

        status.textContent = results.dataset.labelLoading;
        searchTimer = window.setTimeout(function () {
          if (requestController) requestController.abort();
          requestController = new AbortController();
          var endpoint = dialogInput.dataset.predictiveUrl || '/search/suggest';
          var url =
            endpoint.replace(/\/?$/, '.json') +
            '?q=' + encodeURIComponent(query) +
            '&resources[type]=product,collection,page,article' +
            '&resources[limit]=8' +
            '&resources[limit_scope]=all' +
            '&resources[options][unavailable_products]=last';

          fetch(url, { signal: requestController.signal })
            .then(function (response) {
              if (!response.ok) throw new Error('Search request failed');
              return response.json();
            })
            .then(function (data) {
              renderResults(data, query);
            })
            .catch(function (error) {
              if (error.name === 'AbortError') return;
              status.textContent = results.dataset.labelError;
            });
        }, 220);
      }

      function startTypewriter() {
        if (!headerInput || headerInput.value) return;
        var phrases;
        try {
          phrases = JSON.parse(headerInput.dataset.typewriterPhrases || '[]');
        } catch (error) {
          phrases = [];
        }
        if (!phrases.length) return;

        var phraseIndex = 0;
        var letterIndex = 0;
        var deleting = false;

        function tick() {
          if (headerInput.value) {
            typingTimer = window.setTimeout(tick, 250);
            return;
          }
          var phrase = phrases[phraseIndex];
          headerInput.placeholder = phrase.slice(0, letterIndex);

          if (!deleting) {
            letterIndex += 1;
            if (letterIndex > phrase.length) {
              deleting = true;
              typingTimer = window.setTimeout(tick, 1500);
              return;
            }
          } else {
            letterIndex -= 1;
            if (letterIndex < 1) {
              deleting = false;
              phraseIndex = (phraseIndex + 1) % phrases.length;
            }
          }

          typingTimer = window.setTimeout(tick, deleting ? 30 : 65);
        }

        window.clearTimeout(typingTimer);
        tick();
      }

      if (dialogInput) {
        dialogInput.addEventListener('input', function () {
          runSearch(dialogInput.value);
        });
      }

      document.querySelectorAll('[data-help-panel]').forEach(function (helpPanel) {
        var hoverCloseTimer;

        helpPanel.addEventListener('mouseenter', function () {
          window.clearTimeout(hoverCloseTimer);
          helpPanel.setAttribute('open', '');
        });

        helpPanel.addEventListener('mouseleave', function () {
          hoverCloseTimer = window.setTimeout(function () {
            helpPanel.removeAttribute('open');
          }, 180);
        });

        helpPanel.addEventListener('focusin', function () {
          window.clearTimeout(hoverCloseTimer);
          helpPanel.setAttribute('open', '');
        });

        helpPanel.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!helpPanel.contains(document.activeElement)) helpPanel.removeAttribute('open');
          }, 0);
        });

        helpPanel.addEventListener('toggle', function () {
          if (!helpPanel.open) return;
          document.querySelectorAll('[data-help-panel]').forEach(function (otherPanel) {
            if (otherPanel !== helpPanel) otherPanel.removeAttribute('open');
          });
        });
      });

      document.addEventListener('click', function (event) {
        document.querySelectorAll('[data-help-panel][open]').forEach(function (helpPanel) {
          if (!helpPanel.contains(event.target)) helpPanel.removeAttribute('open');
        });
      });

      if (closeButton) closeButton.addEventListener('click', closeSearch);
      if (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeSearch();
        });
        dialog.addEventListener('close', function () {
          if (headerInput) headerInput.value = dialogInput.value;
        });
      }

      startTypewriter();

      function openDrawer() {
        if (!drawer) return;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.body.classList.add('drawer-open');
        if (burger) burger.setAttribute('aria-expanded', 'true');
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        window.setTimeout(function () {
          drawer.hidden = true;
          drawer.querySelectorAll('[data-drawer-root-panel], [data-drawer-sub-panel]').forEach(function (panel) {
            panel.hidden = true;
          });
        }, 300);
      }

      document.querySelectorAll('[data-drawer-open]').forEach(function (button) {
        button.addEventListener('click', openDrawer);
      });
      if (drawer) {
        drawer.querySelectorAll('[data-drawer-close]').forEach(function (button) {
          button.addEventListener('click', closeDrawer);
        });

        drawer.querySelectorAll('[data-drawer-root-open]').forEach(function (button) {
          button.addEventListener('click', function () {
            drawer.querySelectorAll('[data-drawer-root-panel]').forEach(function (panel) {
              panel.hidden = true;
            });
            var panel = button.parentElement.querySelector('[data-drawer-root-panel]');
            if (panel) panel.hidden = false;
          });
        });

        drawer.querySelectorAll('[data-drawer-sub-open]').forEach(function (button) {
          button.addEventListener('click', function () {
            var rootPanel = button.closest('[data-drawer-root-panel]');
            if (rootPanel) {
              rootPanel.querySelectorAll('[data-drawer-sub-panel]').forEach(function (panel) {
                panel.hidden = true;
              });
            }
            var panel = button.parentElement.querySelector('[data-drawer-sub-panel]');
            if (panel) panel.hidden = false;
          });
        });

        drawer.querySelectorAll('[data-drawer-back]').forEach(function (button) {
          button.addEventListener('click', function () {
            var panel = button.closest('[data-drawer-root-panel], [data-drawer-sub-panel]');
            if (panel) panel.hidden = true;
          });
        });
      }


      function initStableMegaMenus() {
        var menuItems = Array.prototype.slice.call(header.querySelectorAll('.nav-horizontal__item.has-children'));
        var closeTimer;
        var activeItem;
        function cancelClose() { window.clearTimeout(closeTimer); }
        function closeItem(item) {
          if (!item) return;
          item.classList.remove('is-mega-open');
          var link = item.querySelector(':scope > .nav__link');
          if (link) link.setAttribute('aria-expanded', 'false');
          if (activeItem === item) activeItem = null;
        }
        function openItem(item) {
          if (!window.matchMedia('(min-width: 1024px)').matches) return;
          cancelClose();
          menuItems.forEach(function (other) {
            if (other !== item) closeItem(other);
          });
          item.classList.remove('is-mega-dismissed');
          item.classList.add('is-mega-open');
          var link = item.querySelector(':scope > .nav__link');
          if (link) link.setAttribute('aria-expanded', 'true');
          activeItem = item;
          window.requestAnimationFrame(function () { var mega = item.querySelector(':scope > .mega'); if (mega) fitMegaPanel(mega); });
        }
        window.addEventListener('resize', function () { if (activeItem) { var mega = activeItem.querySelector(':scope > .mega'); if (mega) fitMegaPanel(mega); } });
        menuItems.forEach(function (item, index) {
          var panel = item.querySelector(':scope > .mega');
          var link = item.querySelector(':scope > .nav__link');
          if (!panel || !link) return;
          if (!panel.id) panel.id = 'HeaderMega-' + index;
          link.setAttribute('aria-controls', panel.id);
          link.setAttribute('aria-expanded', 'false');
          item.addEventListener('mouseenter', function () { openItem(item); });
          item.addEventListener('mouseleave', function () {
            item.classList.remove('is-mega-dismissed');
            cancelClose();
            closeTimer = window.setTimeout(function () {
              if (item.contains(document.activeElement)) return;
              closeItem(item);
            }, 220);
          });
          panel.addEventListener('mouseenter', function () { openItem(item); });
          item.addEventListener('focusin', function () { openItem(item); });
          item.addEventListener('focusout', function () {
            cancelClose();
            closeTimer = window.setTimeout(function () {
              if (!item.contains(document.activeElement) && !item.matches(':hover')) closeItem(item);
            }, 220);
          });
        });
        header.querySelectorAll('.nav-horizontal__item:not(.has-children)').forEach(function (item) {
          item.addEventListener('mouseenter', function () {
            cancelClose();
            menuItems.forEach(closeItem);
          });
        });
        document.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape' || !activeItem) return;
          var item = activeItem;
          cancelClose();
          var link = item.querySelector(':scope > .nav__link');
          if (link && item.contains(document.activeElement)) link.focus();
          closeItem(item);
          item.classList.add('is-mega-dismissed');
        });
        document.addEventListener('click', function (event) {
          if (header.querySelector('.nav') && header.querySelector('.nav').contains(event.target)) return;
          cancelClose();
          menuItems.forEach(closeItem);
        });
      }
      initStableMegaMenus();

      var navTree = header.querySelector('[data-nav-tree]');
      if (navTree) {
        var navMenu = navTree.querySelector('.nav-tree__menu');
        var navTrigger = navTree.querySelector('[data-nav-tree-trigger]');
        var navRoots = Array.prototype.slice.call(navTree.querySelectorAll('[data-nav-tree-root]'));

        function activateNavItem(items, item) {
          items.forEach(function (candidate) {
            candidate.classList.toggle('is-active', candidate === item);
          });
        }

        navRoots.forEach(function (rootItem) {
          function activateRoot() {
            activateNavItem(navRoots, rootItem);
            var subItems = Array.prototype.slice.call(rootItem.querySelectorAll('[data-nav-tree-sub]'));
            if (subItems.length && !subItems.some(function (item) { return item.classList.contains('is-active'); })) {
              activateNavItem(subItems, subItems[0]);
            }
          }

          rootItem.addEventListener('mouseenter', activateRoot);
          rootItem.addEventListener('focusin', activateRoot);

          var subItems = Array.prototype.slice.call(rootItem.querySelectorAll('[data-nav-tree-sub]'));
          subItems.forEach(function (subItem) {
            function activateSub() {
              activateNavItem(subItems, subItem);
            }
            subItem.addEventListener('mouseenter', activateSub);
            subItem.addEventListener('focusin', activateSub);
          });
        });

        if (navRoots.length) {
          activateNavItem(navRoots, navRoots[0]);
          var initialSubs = Array.prototype.slice.call(navRoots[0].querySelectorAll('[data-nav-tree-sub]'));
          if (initialSubs.length) activateNavItem(initialSubs, initialSubs[0]);
        }

        if (navMenu && navTrigger) {
          navMenu.addEventListener('mouseenter', function () {
            navTrigger.setAttribute('aria-expanded', 'true');
          });
          navMenu.addEventListener('mouseleave', function () {
            if (!navMenu.classList.contains('is-open')) navTrigger.setAttribute('aria-expanded', 'false');
          });
          navTrigger.addEventListener('click', function () {
            var isOpen = navMenu.classList.toggle('is-open');
            navTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          });
          document.addEventListener('click', function (event) {
            if (navMenu.contains(event.target)) return;
            navMenu.classList.remove('is-open');
            navTrigger.setAttribute('aria-expanded', 'false');
          });
        }
      }

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (drawer && !drawer.hidden) closeDrawer();
        var openNavMenu = header.querySelector('.nav-tree__menu.is-open');
        if (openNavMenu) {
          openNavMenu.classList.remove('is-open');
          var trigger = openNavMenu.querySelector('[data-nav-tree-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeader);
    } else {
      initHeader();
    }
    document.addEventListener('shopify:section:load', initHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var input = document.getElementById('CartDiscountCode');
    var button = document.getElementById('CartDiscountApply');
    var status = document.getElementById('CartDiscountStatus');

    function applyDiscount() {
      var code = input.value.trim();
      if (!code) {
        status.textContent = 'Lütfen bir indirim kodu yazın.';
        input.focus();
        return;
      }
      status.textContent = 'Kod uygulanıyor…';
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
    }

    if (input && button) {
      button.addEventListener('click', applyDiscount);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyDiscount();
        }
      });
    }

    document.querySelectorAll('[data-cart-qty]').forEach(function (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var quantity = parseInt(qtyInput.value, 10);

        if (isNaN(quantity) || quantity < 0) {
          qtyInput.value = qtyInput.defaultValue;
          return;
        }

        if (String(quantity) === String(qtyInput.defaultValue)) return;

        qtyInput.disabled = true;

        fetch(qtyInput.dataset.changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: Number(qtyInput.dataset.line),
            quantity: quantity
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart change failed');
            return response.json();
          })
          .then(function () {
            window.location.assign(document.querySelector('.cart-form').action);
          })
          .catch(function () {
            qtyInput.disabled = false;
            qtyInput.value = qtyInput.defaultValue;
          });
      });
    });

    var clearButton = document.querySelector('[data-cart-clear]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        if (clearButton.disabled) return;
        if (!window.confirm('Sepetteki tüm ürünleri kaldırmak istediğinizden emin misiniz?')) return;
        clearButton.disabled = true;
        clearButton.textContent = 'Sepet kaldırılıyor…';

        fetch(clearButton.dataset.clearUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart clear failed');
            return response.json();
          })
          .then(function () {
            window.location.assign(document.querySelector('.cart-form').action);
          })
          .catch(function () {
            clearButton.disabled = false;
            clearButton.textContent = 'Sepeti Kaldır';
          });
      });
    }

    var relatedTrack = document.querySelector('[data-related-track]');
    var relatedPrev = document.querySelector('[data-related-prev]');
    var relatedNext = document.querySelector('[data-related-next]');

    if (relatedTrack && relatedPrev && relatedNext) {
      function relatedStep() {
        var card = relatedTrack.querySelector('.pcard');
        if (!card) return relatedTrack.clientWidth * 0.82;
        var gap = parseFloat(window.getComputedStyle(relatedTrack).columnGap) || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function syncRelatedButtons() {
        var maxScroll = relatedTrack.scrollWidth - relatedTrack.clientWidth;
        relatedPrev.disabled = relatedTrack.scrollLeft <= 2;
        relatedNext.disabled = relatedTrack.scrollLeft >= maxScroll - 2;
      }

      relatedPrev.addEventListener('click', function () {
        relatedTrack.scrollBy({ left: -relatedStep() * 2, behavior: 'smooth' });
      });
      relatedNext.addEventListener('click', function () {
        relatedTrack.scrollBy({ left: relatedStep() * 2, behavior: 'smooth' });
      });
      relatedTrack.addEventListener('scroll', syncRelatedButtons, { passive: true });
      window.addEventListener('resize', syncRelatedButtons);
      syncRelatedButtons();
    }

    document.querySelectorAll('[data-cart-remove]').forEach(function (removeLink) {
      removeLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (removeLink.classList.contains('is-loading')) return;

        removeLink.classList.add('is-loading');
        removeLink.setAttribute('aria-disabled', 'true');

        fetch(removeLink.dataset.changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: Number(removeLink.dataset.line),
            quantity: 0
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart change failed');
            return response.json();
          })
          .then(function () {
            window.location.assign(document.querySelector('.cart-form').action);
          })
          .catch(function () {
            window.location.assign(removeLink.href);
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-collection-sort]');
    if (!select) return;

    var form = select.closest('[data-collection-sort-form]');
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekly-offers"] && !Shopify.designMode) return;
  try {
    
function initWeekly(root){if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-track]');const move=d=>{const item=track.firstElementChild;if(item)track.scrollBy({left:d*(item.getBoundingClientRect().width+18),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})};root.querySelector('[data-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-next]').addEventListener('click',()=>move(1));const clock=root.querySelector('[data-countdown]');if(clock){const end=Date.parse(clock.dataset.end);let timer;const update=()=>{const diff=end-Date.now();if(!Number.isFinite(end)||diff<=0){clock.hidden=true;clearInterval(timer);return}clock.hidden=false;const s=Math.floor(diff/1000);clock.querySelector('[data-time]').textContent=[Math.floor(s/3600),Math.floor(s/60)%60,s%60].map(v=>String(v).padStart(2,'0')).join(' : ')};update();if(Number.isFinite(end)&&end>Date.now()){timer=setInterval(update,1000);root._weeklyTimer=timer}}}
document.querySelectorAll('.nn-weekly').forEach(initWeekly);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.nn-weekly').forEach(initWeekly));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.nn-weekly').forEach(root=>clearInterval(root._weeklyTimer)));

  } catch(e) { console.error(e); }
})();
})();
